// The blog API returns the author's display name as `user_name` (the post's user, or null when it has none).
// Show it only when there really is one. A missing author is left out entirely rather than replaced by a
// made-up name, and the generic placeholder accounts ("Default User", "Anonymous") are treated as "no
// author", because showing them would be as misleading as the old hardcoded "Admin".
const PLACEHOLDER_NAMES = ["anonymous", "default user", "unknown"];

export function getAuthorName(post) {
  const name = post && typeof post.user_name === "string" ? post.user_name.replace(/\s+/g, " ").trim() : "";
  if (!name || PLACEHOLDER_NAMES.includes(name.toLowerCase())) return null;
  return name;
}
